import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import RingLoader from "react-spinners/ScaleLoader";

//componentes
import "./nomina.css";
import Alert from "../../modal/alert";

function ReporteDecimoE(props) {
  const [mensajealerta, setmensajealerta] = React.useState(false);
  const [paso, setpaso] = React.useState(false);
  const [loading, setloading] = React.useState(false);
  const [anio, setanio] = React.useState([]);
  const [mes, setmes] = React.useState([]);
  const [opcionR, setopcionR] = React.useState([]);
  const [tituloM, settituloM] = React.useState("");
  const [cuerpoM, setcuerpoM] = React.useState("");
  const [trimestre, settrimestre] = React.useState(0);
  const [anopagar, setanopagar] = React.useState("");
  const [mesapagar, setmesapagar] = React.useState("");
  const [sede, setsede] = React.useState("");

  const onChange = (e) => {
    let index = e.target.getAttribute("id");
    if (index === "trimestre") {
      settrimestre(e.target.value);
    }
    if (index === "anopagar") {
      setanopagar(e.target.value);
    }
    if (index === "mesapagar") {
      setmesapagar(e.target.value);
    }
    if (index === "opcionR") {
      setopcionR(e.target.value);
    }
    if (index === "sede") {
      setsede(e.target.value);
    }
  };

  const generarPrenomina = () => {
    setloading(true);

    let data = new FormData();
    data.append("anoapagar", anopagar);
    data.append("trimestre", trimestre);
    data.append("mesapagar", mesapagar);
    data.append("sede", sede);
    data.append("usuario", props.usuario1.password);
    data.append("boton", "calcularPrenomina");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapiasprueba/backend/prenomina.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        //let ximedicos = res.data.variable2;
        if (res.data.variable1) {
          setpaso(true);
          setloading(false);
        } else {
          setpaso(false);
        }
      });
  };

  const otraConsulta = () => {
    setpaso(false);
  };

  const handleClose = () => {
    setmensajealerta(false);
  };

  const cargarFechas = () => {
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapiasprueba/backend/fecha.php";
    axios.post(xurl).then((res) => {
      if (res.data.variable1) {
        let xmes = res.data.variable1;
        let xanio = res.data.variable2;
        //let xdia = res.data.variable3;
        //dia: xdia,
        setmes(xmes);
        setanio(xanio);
      }
    });
  };

  const buscarTipoReporte = () => {
    if (opcionR === "1") especialistaTodo();
    if (opcionR === "2") especialistaTotales();
  };
  const especialistaTotales = () => {
    let data = new FormData();
    data.append("anoapagar", anopagar);
    data.append("trimestre", trimestre);
    data.append("mesapagar", mesapagar);
    data.append("sede", sede);
    data.append("usuario", props.usuario1.password);
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapiasprueba/fpdf/reportes/prenominaTotales.php",
      responseType: "arraybuffer",
      data: data,
    }).then(function (response) {
      let blob = new Blob([response.data], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
    });
  };
  const especialistaTodo = () => {
    let data = new FormData();
    data.append("anoapagar", anopagar);
    data.append("trimestre", trimestre);
    data.append("mesapagar", mesapagar);
    data.append("sede", sede);
    data.append("usuario", props.usuario1.password);
    axios({
      method: "post",
      url:
        "https://institutobilinguelasnaciones.com/terapiasprueba/fpdf/reportes/prenomina.php",
      responseType: "arraybuffer",
      data: data,
    }).then(function (response) {
      let blob = new Blob([response.data], { type: "application/pdf" });
      var fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
    });
  };

  React.useEffect(() => {
    //console.log(props.cedulaempleado);
    cargarFechas();
  }, []);

  return (
    <div className="principal-pago row">
      <div className="contenedor-cxc col-12">
        <div className="titulo-cxc ">
          <p>GENERAR PRE-NOMINA ESPECIALISTAS. </p>
        </div>
        {mensajealerta === true && (
          <Alert
            tituloMensaje={tituloM}
            cuerpoMensaje={cuerpoM}
            open={mensajealerta}
            handleClose={handleClose}
          />
        )}
        {loading && (
          <div className="cont-spinner row">
            <div className="spinner col-6">
              <RingLoader
                clasName="spinner"
                sizeUnit={"px"}
                size={160}
                width={19}
                radius={20}
                height={160}
                color={"#48e120"}
                loading={loading}
              />
            </div>
          </div>
        )}

        <div className="cont-listmedi row">
          <div className="cont-personal col-2">
            <label className="titulo-salario2">Sede.</label>

            <select
              id="sede"
              name="sede"
              value={sede}
              onChange={onChange}
            >
              <option>-Seleccione Sucursal-</option>
              <option value="1">Bella Vista</option>
              <option value="2">Arraijan</option>
              <option value="3">Chorrera</option>
              {/* <option value="4">Todas</option> */}
            </select>
          </div>
          <div className="cont-personal col-3">
            <label className="titulo-salario2">
              Quincena a consultar.
              <select
                id="trimestre"
                name="trimestre"
                value={typeof trimestre !== "undefined" ? trimestre : ""}
                onChange={onChange}
              >
                <option value="0">Seleccione Quincena</option>
                <option value="1">Primera Quincena.</option>
                <option value="2">Segunda Quincena.</option>
              </select>
            </label>
          </div>
          <div className="cont-personal col-2">
            <label className="titulo-salario2">
              Mes a Pagar.
              <select
                id="mesapagar"
                name="mesapagar"
                value={typeof mesapagar !== "undefined" ? mesapagar : ""}
                onChange={onChange}
              >
                <option value="0">Mes a Pagar</option>
                {mes.map((item, i) => {
                  return (
                    <option key={i} value={item.variable1}>
                      {item.variable2}
                    </option>
                  );
                })}
              </select>
            </label>
          </div>
          <div className="cont-personal col-2">
            <label className="titulo-salario2">
              Año a Pagar.
              <select
                id="anopagar"
                name="anopagar"
                value={typeof anopagar !== "undefined" ? anopagar : ""}
                onChange={onChange}
              >
                <option value="0">Año a Pagar</option>
                {anio.map((item, i) => {
                  return (
                    <option key={i} value={item.variable1}>
                      {item.variable1}
                    </option>
                  );
                })}
              </select>
            </label>
          </div>
        </div>
        {}
        {paso === true && (
          <div className="cont-listmedi row">
            <div className="cont-personal col-4">
              <label className="titulo-salario2">
                Seleccione un Reporte.
                <select
                  id="opcionR"
                  name="opcionR"
                  value={typeof opcionR !== "undefined" ? opcionR : ""}
                  onChange={onChange}
                >
                  <option value="0"></option>
                  <option value="1">
                    especialistas por estudios Cobrados.
                  </option>
                  <option value="2">especialistas Totales.</option>
                </select>
              </label>
            </div>
            <div className="cont-personal col-4">
              <button className="botonN" onClick={buscarTipoReporte}>
                Imprimir
              </button>
            </div>
          </div>
        )}

        <div className="cont-personal col-12">
          {paso === false && (
            <button className="botonN" onClick={generarPrenomina}>
              Generar Pre-Nomina
            </button>
          )}
          {paso === true && (
            <button className="botonN" onClick={otraConsulta}>
              Otra Consulta
            </button>
          )}
          <button className="boton" onClick={props.personalClose}>
            Salir
          </button>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    usuario1: state.usuario1,
    token: state.token,
  };
};
export default connect(mapStateToProps)(ReporteDecimoE);
